import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Navbar, Nav, Image } from 'react-bootstrap'
import './NavBar.css';

import brandlogo from './../../_assets/images/NVRE_logo.png';

class NavBar extends Component {

    

    render() {
        
        // const collapsed = this.state.collapsed;
        // const classOne = collapsed ? 'collapsed navbar-toggler' : 'navbar-toggler';
        // const classTwo = collapsed ? 'navbar-collapse collapse' : 'navbar-collapse collapse show';

        return (
            <Navbar collapseOnSelect expand="md" bg="midnight" fixed="top" variant="dark">
                <Navbar.Brand as={Link} to="/">
                    <Image
                        src={brandlogo}
                        alt="NVRE"
                        width="40"
                        height="40"
                        className="d-inline-block align-top"
                    />
                    <span className="brand-text">{' NVRE'}</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav" >
                    <Nav className="ml-auto text-center text-uppercase">
                        <Nav.Link as={Link} to="/Home" >Home</Nav.Link>
                        <Nav.Link as={Link} to="/Services">Services</Nav.Link>
                        <Nav.Link as={Link} to="/Products">Products</Nav.Link>
                        {/* <Nav.Link as={Link} to="/Careers">careers</Nav.Link> */}
                        <Nav.Link as={Link} to='/About'>About Us</Nav.Link>
                        <Nav.Link as={Link} to='/Contactus'>Contact Us</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        )
    }
}

export default NavBar;